import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Combustiveis } from '../model/RetornoGetCombustiveis';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-modal-ajuste-preco-rede-especial',
  templateUrl: './modal-ajuste-preco-rede-especial.component.html',
  styleUrls: ['./modal-ajuste-preco-rede-especial.component.scss'],
})
export class ModalAjustePrecoRedeEspecialComponent implements OnInit {
  @Input() combustivel: Combustiveis | null = null;
  @Output() salvarModificacoes = new EventEmitter<boolean>();

  public redeEspecialForm = new FormGroup({
    dataInicio: new FormControl(''),
    datCadastro: new FormControl(''),
    dscStatusAcordo: new FormControl(''),
    descricaoCombustivel: new FormControl(''),
    precoBomba: new FormControl(0),
    descontoEmReais: new FormControl(0),
    precoRedeEspecial: new FormControl(0),
    tituloBomba: new FormControl('Preço na bomba'),
    tituloDesconto: new FormControl('Desconto em R$'),
    tituloRedeEspecial: new FormControl('Rede Especial'),
    descricaoBomba: new FormControl('Preço na bomba'),
    descricaoDesconto: new FormControl('Desconto em R$'),
    descricaoRedeEspecial: new FormControl('Preço p/ clientes Rede Especial'),
  });

  ngOnInit(): void {
    
    this.redeEspecialForm.patchValue({
      dataInicio: this.combustivel?.combustivel.datInicio,
      datCadastro: this.combustivel?.combustivel.datCadastro,
      dscStatusAcordo: this.combustivel?.combustivel.dscStatusAcordo,
      descricaoCombustivel : this.combustivel?.descricaoCombustivel,
      precoBomba: this.combustivel?.combustivel.precos.precoUnitario[0].preco,
      descontoEmReais: this.combustivel?.combustivel.precos.precoRedeEspecial[0].vlrDesconto,
      precoRedeEspecial: this.combustivel?.combustivel.precos.precoRedeEspecial[0].preco,
      
      tituloBomba: this.combustivel?.combustivel.precos.precoUnitario[0].titulo,
      tituloDesconto: this.combustivel?.combustivel.precos.precoUnitario[0].titulo,
      tituloRedeEspecial: this.combustivel?.combustivel.precos.precoRedeEspecial[0].titulo,
      
      descricaoBomba: this.combustivel?.combustivel.precos.precoUnitario[0].descricao,
      descricaoDesconto: this.combustivel?.combustivel.precos.precoUnitario[0].descricao,
      descricaoRedeEspecial: this.combustivel?.combustivel.precos.precoRedeEspecial[0].descricao,
    });
    
  }



  updateValor(event: any, campo: string) {
    event.preventDefault();
    const valor = event.target.value;
    const precoBomba = this.redeEspecialForm.controls['precoBomba'].value || 0;
    const desconto =
      this.redeEspecialForm.controls['descontoEmReais'].value || 0;

      if(desconto < precoBomba){
      
      switch (campo) {
        case 'desconto':
          const novoValor = Math.round((precoBomba - desconto) * 100) / 100;
          this.redeEspecialForm.patchValue({ precoRedeEspecial: novoValor });
          break;
          
          case 'precoRedeEspecial':
            const novoDesconto = Math.round((precoBomba - valor) * 100) / 100;
            this.redeEspecialForm.patchValue({ descontoEmReais: novoDesconto });
            break;
          }

          }else{
            this.redeEspecialForm.patchValue({ precoRedeEspecial: precoBomba });
            this.redeEspecialForm.patchValue({ descontoEmReais: 0 });
          }

  }

  salvarModificacoesCombustivel(param: boolean) {
    if(this.combustivel){
      this.combustivel.combustivel.precos.precoRedeEspecial[0].vlrDesconto = this.redeEspecialForm.get('descontoEmReais')?.value || 0;
    }

    this.salvarModificacoes.emit(param);
  }
}
